package com.tixforgigs.configurator

import kotlin.String

internal object BuildKonfig {
  public val HOST_URL: String = "https://staging.configurator.tixforgigs.shop"

  public val SENTRY_URL: String =
      "https://cb5edbc2c3fcc0b4db3adbf04fa076d1@o1280835.ingest.us.sentry.io/4510790007128064"
}
